// A trap adds a second hit to the current enemy turn. Reusable defenses apply
// to each hit; shields and clash-only defenses share their remaining charge.
export const resolveEnemyAttacks = ({
  damage,
  count,
  defenses,
  decoy = false,
}) => {
  const remaining = defenses.map(({ amount }) => amount);
  const blocked = defenses.map(() => 0);
  const attacks = [];
  let decoyDamage = 0;
  for (let hit = 0; hit < count; hit += 1) {
    let incoming = damage;
    defenses.forEach((defense, index) => {
      const amount = Math.min(
        incoming,
        defense.once ? remaining[index] : defense.amount
      );
      incoming -= amount;
      blocked[index] += amount;
      if (defense.once) remaining[index] -= amount;
    });
    if (decoy && decoyDamage === 0 && incoming > 0) {
      decoyDamage = incoming;
      incoming = 0;
    }
    attacks.push(incoming);
  }
  return {
    damage: attacks.reduce((sum, amount) => sum + amount, 0),
    damagingAttackCount: attacks.filter((amount) => amount > 0).length,
    decoyDamage,
    decoyIntercepted: decoyDamage > 0,
    reductions: defenses
      .map((defense, index) => ({
        id: defense.id,
        amount: blocked[index],
        message: defense.message?.(blocked[index]),
      }))
      .filter(({ amount }) => amount > 0),
  };
};
